import { objectOf } from "@altostra/type-validations";
import { boolean, number } from "@altostra/type-validations/lib/primitives";

import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult,
  PutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult,
} from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult>({
    start_hour: number,
    start_minute: number,
    end_hour: number,
    end_minute: number,
    use_user_timezone: boolean,
  });

export const isPutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult =
  objectOf<PutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult>({
    start_hour: number,
    start_minute: number,
    end_hour: number,
    end_minute: number,
    use_user_timezone: boolean,
  });
